(function () {
  "use strict";

  /*
   * DRIP STREET — ZOOM POR PRESSÃO NA PDP
   *
   * Segurou a imagem sem mover: ativa o zoom.
   * Soltou: volta ao tamanho normal.
   * Arrastou para trocar a foto ou rolar: o zoom nem chega a iniciar.
   */

  if (window.dsPdpImmediateHoldZoomV1) return;
  window.dsPdpImmediateHoldZoomV1 = true;

  /*
   * Bloqueia controladores antigos do arquivo separado.
   */
  window.dsPdpMobileZoomControllerV4 = true;
  window.dsPdpMobileZoomControllerV5 = true;
  window.dsPdpMobileZoomControllerV6 = true;

  var MOBILE_QUERY = "(max-width: 989px)";
  var ZOOM_SCALE = 1.95;

  /*
   * Pequeno movimento cancela o zoom pendente antes que ele apareça.
   * Isso evita o "piscar" ao deslizar horizontalmente o carrossel.
   */
  var MOVE_CANCEL = 8;

  /*
   * O zoom só entra depois de uma pressão curta e estável.
   * Um swipe normal começa antes desse tempo e cancela o timer.
   */
  var ZOOM_HOLD_DELAY = 180;

  var currentImage = null;
  var currentTarget = null;

  var touching = false;
  var active = false;
  var moved = false;

  var startX = 0;
  var startY = 0;
  var lastX = 0;
  var lastY = 0;

  var cleanupTimer = null;
  var suppressClickUntil = 0;

  var zoomLocked = false;
  var zoomStartTimer = null;

  var pendingImage = null;
  var pendingClientX = 0;
  var pendingClientY = 0;

  var panX = 0;
  var panY = 0;
  var maxPanX = 0;
  var maxPanY = 0;

  function isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function injectStyles() {
    if (
      document.getElementById(
        "DsPdpImmediateHoldZoomStylesV1"
      )
    ) {
      return;
    }

    var style = document.createElement("style");

    style.id =
      "DsPdpImmediateHoldZoomStylesV1";

    style.textContent = [
      "@media screen and (max-width:989px){",

      /*
       * Impede menu nativo e arraste da imagem.
       */
      '[class*="ai-sneaker-pdp-mobile-gallery-"] img{',
      "-webkit-touch-callout:none!important;",
      "-webkit-user-select:none!important;",
      "user-select:none!important;",
      "-webkit-user-drag:none!important;",
      "user-drag:none!important;",
      "}",

      /*
       * Enquanto o zoom estiver ativo,
       * libera a imagem para ultrapassar
       * o quadrado da galeria.
       */
      "html.ds-pdp-immediate-zooming ",
      '[class*="ai-sneaker-pdp-image-"],',

      "html.ds-pdp-immediate-zooming ",
      '[class*="ai-sneaker-pdp-gallery-"],',

      "html.ds-pdp-immediate-zooming ",
      '[class*="ai-sneaker-pdp-mobile-gallery-"],',

      "html.ds-pdp-immediate-zooming ",
      '[class*="ai-sneaker-pdp-mobile-track-"],',

      "html.ds-pdp-immediate-zooming ",
      "[data-mobile-slide],",

      "body.ds-pdp-immediate-zooming ",
      '[class*="ai-sneaker-pdp-image-"],',

      "body.ds-pdp-immediate-zooming ",
      '[class*="ai-sneaker-pdp-gallery-"],',

      "body.ds-pdp-immediate-zooming ",
      '[class*="ai-sneaker-pdp-mobile-gallery-"],',

      "body.ds-pdp-immediate-zooming ",
      '[class*="ai-sneaker-pdp-mobile-track-"],',

      "body.ds-pdp-immediate-zooming ",
      "[data-mobile-slide]{",
      "overflow:visible!important;",
      "}",

      /*
       * Elemento ampliado.
       */
      ".ds-pdp-immediate-zoom-target{",
      "position:relative!important;",
      "z-index:999999!important;",
      "transform-origin:",
      "var(--ds-immediate-origin-x,50%) ",
      "var(--ds-immediate-origin-y,50%)!important;",
      "will-change:transform!important;",
      "transition:",
      "transform 160ms cubic-bezier(.22,.61,.36,1)!important;",
      "}",

      ".ds-pdp-immediate-zoom-target.is-active{",
      "transform:",
      "translate3d(",
      "var(--ds-immediate-pan-x,0px),",
      "var(--ds-immediate-pan-y,0px),",
      "0",
      ") ",
      "scale(var(--ds-immediate-scale,1.95))!important;",
      "transition:",
      "transform 60ms linear!important;",
      "}",

      /*
       * Durante o zoom, desativa snap do carrossel.
       */
      "html.ds-pdp-immediate-zooming ",
      '[class*="ai-sneaker-pdp-mobile-track-"],',

      "body.ds-pdp-immediate-zooming ",
      '[class*="ai-sneaker-pdp-mobile-track-"]{',
      "scroll-snap-type:none!important;",
      "}",

      "}"
    ].join("");

    document.head.appendChild(style);
  }

  function removeOldZoom() {
    [
      "DsPdpMobileZoomStylesV4",
      "DsPdpMobileZoomStylesV5",
      "DsPdpMobileZoomStylesV6"
    ].forEach(function (styleId) {
      var oldStyle =
        document.getElementById(styleId);

      if (oldStyle) {
        oldStyle.remove();
      }
    });

    document
      .querySelectorAll(
        ".ds-pdp-zoom-surface"
      )
      .forEach(function (surface) {
        surface.remove();
      });

    document
      .querySelectorAll(
        ".ds-pdp-zoom-modal"
      )
      .forEach(function (modal) {
        modal.remove();
      });

    document
      .querySelectorAll(
        ".ds-hold-zoom-lens"
      )
      .forEach(function (lens) {
        lens.remove();
      });

    document
      .querySelectorAll(
        ".ds-pdp-zoom-target," +
        ".ds-pdp-zoom-preview," +
        ".ds-pdp-zoomed," +
        ".ds-pdp-zoom-target-v6," +
        ".is-previewing," +
        ".is-full-zoom," +
        ".is-hold-zooming"
      )
      .forEach(function (element) {
        element.classList.remove(
          "ds-pdp-zoom-target",
          "ds-pdp-zoom-preview",
          "ds-pdp-zoom-preview-release",
          "ds-pdp-zoomed",
          "ds-pdp-zoom-target-v6",
          "is-previewing",
          "is-full-zoom",
          "is-hold-zooming"
        );

        element.style.removeProperty(
          "--ds-zoom-x"
        );

        element.style.removeProperty(
          "--ds-zoom-y"
        );

        element.style.removeProperty(
          "--ds-zoom-scale"
        );

        element.style.removeProperty(
          "--ds-preview-scale"
        );

        element.style.removeProperty(
          "--ds-pdp-preview-scale"
        );

        element.style.removeProperty(
          "--ds-pdp-full-scale"
        );

        element.style.removeProperty(
          "--ds-origin-x"
        );

        element.style.removeProperty(
          "--ds-origin-y"
        );
      });

    document.documentElement.classList.remove(
      "ds-pdp-zoom-open",
      "ds-hold-img-zooming",
      "ds-pdp-zoom-active-v6"
    );

    document.body.classList.remove(
      "ds-pdp-zoom-open",
      "ds-hold-img-zooming",
      "ds-pdp-zoom-active-v6"
    );
  }

  function getGallery(element) {
    if (!element || !element.closest) {
      return null;
    }

    return element.closest(
      '[class*="ai-sneaker-pdp-mobile-gallery-"]'
    );
  }

  function getImage(element) {
    if (!isMobile() || !element) {
      return null;
    }

    var gallery = getGallery(element);

    if (!gallery) {
      return null;
    }

    if (
      element.tagName &&
      element.tagName.toLowerCase() === "img"
    ) {
      return element;
    }

    var slide =
      element.closest &&
      element.closest("[data-mobile-slide]");

    if (!slide) {
      return null;
    }

    return slide.querySelector("img");
  }

  function getZoomTarget(image) {
    if (!image) {
      return null;
    }

    /*
     * Usa o mesmo tipo de elemento do zoom antigo:
     * o envoltório direto da imagem.
     */
    return image.parentElement || image;
  }

  function updateOrigin(clientX, clientY) {
    if (!currentTarget) {
      return;
    }

    var rect =
      currentTarget.getBoundingClientRect();

    if (!rect.width || !rect.height) {
      return;
    }

    var x = clamp(
      (
        (clientX - rect.left) /
        rect.width
      ) * 100,
      0,
      100
    );

    var y = clamp(
      (
        (clientY - rect.top) /
        rect.height
      ) * 100,
      0,
      100
    );

    currentTarget.style.setProperty(
      "--ds-immediate-origin-x",
      x + "%"
    );

    currentTarget.style.setProperty(
      "--ds-immediate-origin-y",
      y + "%"
    );
  }

  function activateZoom(image, clientX, clientY) {
    if (!image || !touching || moved) {
      return;
    }

    clearTimeout(cleanupTimer);
    clearTimeout(zoomStartTimer);

    cleanupTimer = null;
    zoomStartTimer = null;

    currentImage = image;
    currentTarget = getZoomTarget(image);

    if (!currentTarget) {
      return;
    }

    active = true;

    /*
     * Como o zoom só entra após o tempo de pressão,
     * o gesto já foi confirmado como "segurar".
     * Portanto o carrossel pode ser travado imediatamente.
     */
    zoomLocked = true;

    panX = 0;
    panY = 0;

    /*
     * Mede o elemento antes da ampliação para calcular
     * até onde ele poderá ser movimentado.
     */
    var baseRect =
      currentTarget.getBoundingClientRect();

    maxPanX = Math.max(
      0,
      baseRect.width *
        (ZOOM_SCALE - 1) /
        2
    );

    maxPanY = Math.max(
      0,
      baseRect.height *
        (ZOOM_SCALE - 1) /
        2
    );

    currentTarget.classList.add(
      "ds-pdp-immediate-zoom-target"
    );

    currentTarget.style.setProperty(
      "--ds-immediate-scale",
      String(ZOOM_SCALE)
    );

    currentTarget.style.setProperty(
      "--ds-immediate-pan-x",
      "0px"
    );

    currentTarget.style.setProperty(
      "--ds-immediate-pan-y",
      "0px"
    );

    updateOrigin(clientX, clientY);

    document.documentElement.classList.add(
      "ds-pdp-immediate-zooming"
    );

    document.body.classList.add(
      "ds-pdp-immediate-zooming"
    );

    void currentTarget.offsetWidth;

    currentTarget.classList.add(
      "is-active"
    );
  }

  function cancelPendingZoom() {
    clearTimeout(zoomStartTimer);

    zoomStartTimer = null;
    pendingImage = null;
    pendingClientX = 0;
    pendingClientY = 0;
  }

  function removeZoomImmediately() {
    clearTimeout(cleanupTimer);
    cancelPendingZoom();

    cleanupTimer = null;
    zoomLocked = false;

    document.documentElement.classList.remove(
      "ds-pdp-immediate-zooming"
    );

    document.body.classList.remove(
      "ds-pdp-immediate-zooming"
    );

    if (currentTarget) {
      currentTarget.classList.remove(
        "is-active",
        "ds-pdp-immediate-zoom-target"
      );

      currentTarget.style.removeProperty(
        "--ds-immediate-scale"
      );

      currentTarget.style.removeProperty(
        "--ds-immediate-origin-x"
      );

      currentTarget.style.removeProperty(
        "--ds-immediate-origin-y"
      );

      currentTarget.style.removeProperty(
        "--ds-immediate-pan-x"
      );

      currentTarget.style.removeProperty(
        "--ds-immediate-pan-y"
      );
    }

    currentImage = null;
    currentTarget = null;

    active = false;
    touching = false;
    moved = false;

    panX = 0;
    panY = 0;
    maxPanX = 0;
    maxPanY = 0;
  }

  function releaseZoom() {
    cancelPendingZoom();

    zoomLocked = false;

    document.documentElement.classList.remove(
      "ds-pdp-immediate-zooming"
    );

    document.body.classList.remove(
      "ds-pdp-immediate-zooming"
    );

    var releasedTarget = currentTarget;

    if (releasedTarget) {
      releasedTarget.classList.remove(
        "is-active"
      );

      cleanupTimer = window.setTimeout(
        function () {
          releasedTarget.classList.remove(
            "ds-pdp-immediate-zoom-target"
          );

          releasedTarget.style.removeProperty(
            "--ds-immediate-scale"
          );

          releasedTarget.style.removeProperty(
            "--ds-immediate-origin-x"
          );

          releasedTarget.style.removeProperty(
            "--ds-immediate-origin-y"
          );

          releasedTarget.style.removeProperty(
            "--ds-immediate-pan-x"
          );

          releasedTarget.style.removeProperty(
            "--ds-immediate-pan-y"
          );
        },
        190
      );
    }

    currentImage = null;
    currentTarget = null;

    active = false;
    touching = false;
    moved = false;

    panX = 0;
    panY = 0;
    maxPanX = 0;
    maxPanY = 0;
  }

  document.addEventListener(
    "touchstart",
    function (event) {
      if (
        !isMobile() ||
        !event.touches ||
        event.touches.length !== 1
      ) {
        return;
      }

      var image = getImage(event.target);

      if (!image) {
        return;
      }

      var touch = event.touches[0];

      cancelPendingZoom();

      touching = true;
      active = false;
      moved = false;
      zoomLocked = false;

      startX = touch.clientX;
      startY = touch.clientY;
      lastX = touch.clientX;
      lastY = touch.clientY;

      pendingImage = image;
      pendingClientX = touch.clientX;
      pendingClientY = touch.clientY;

      suppressClickUntil =
        Date.now() + 700;

      /*
       * Não amplia no touchstart.
       * Aguarda uma pressão curta sem movimento.
       * Se houver swipe/scroll, touchmove cancela este timer.
       */
      zoomStartTimer = window.setTimeout(
        function () {
          if (
            touching &&
            !moved &&
            pendingImage
          ) {
            activateZoom(
              pendingImage,
              pendingClientX,
              pendingClientY
            );
          }
        },
        ZOOM_HOLD_DELAY
      );
    },
    {
      capture: true,
      passive: true
    }
  );

  document.addEventListener(
    "touchmove",
    function (event) {
      if (
        !touching ||
        !event.touches ||
        event.touches.length !== 1
      ) {
        return;
      }

      var touch = event.touches[0];

      lastX = touch.clientX;
      lastY = touch.clientY;

      var deltaX =
        touch.clientX - startX;

      var deltaY =
        touch.clientY - startY;

      var distance = Math.hypot(
        deltaX,
        deltaY
      );

      /*
       * Enquanto o zoom ainda não entrou, qualquer movimento
       * real de swipe/scroll cancela o timer antes de ampliar.
       */
      if (
        !active &&
        distance > MOVE_CANCEL
      ) {
        moved = true;
        cancelPendingZoom();
        return;
      }

      /*
       * Depois que a pressão foi reconhecida como zoom,
       * movimenta somente a imagem ampliada.
       */
      if (
        active &&
        zoomLocked &&
        currentTarget
      ) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        panX = clamp(
          deltaX,
          -maxPanX,
          maxPanX
        );

        panY = clamp(
          deltaY,
          -maxPanY,
          maxPanY
        );

        currentTarget.style.setProperty(
          "--ds-immediate-pan-x",
          panX + "px"
        );

        currentTarget.style.setProperty(
          "--ds-immediate-pan-y",
          panY + "px"
        );
      }
    },
    {
      capture: true,
      passive: false
    }
  );

  document.addEventListener(
    "touchend",
    function () {
      cancelPendingZoom();

      if (active) {
        releaseZoom();
        return;
      }

      touching = false;
      moved = false;
      zoomLocked = false;
    },
    {
      capture: true,
      passive: true
    }
  );

  document.addEventListener(
    "touchcancel",
    function () {
      cancelPendingZoom();

      if (active) {
        releaseZoom();
        return;
      }

      touching = false;
      moved = false;
      zoomLocked = false;
    },
    {
      capture: true,
      passive: true
    }
  );

  /*
   * Bloqueia o modal antigo ao finalizar o toque.
   */
  document.addEventListener(
    "click",
    function (event) {
      if (!isMobile()) {
        return;
      }

      var gallery = getGallery(event.target);

      if (!gallery) {
        return;
      }

      if (
        Date.now() < suppressClickUntil ||
        getImage(event.target)
      ) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        return false;
      }
    },
    true
  );

  document.addEventListener(
    "contextmenu",
    function (event) {
      if (
        isMobile() &&
        getGallery(event.target)
      ) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        return false;
      }
    },
    true
  );

  document.addEventListener(
    "dragstart",
    function (event) {
      if (
        isMobile() &&
        getGallery(event.target)
      ) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        return false;
      }
    },
    true
  );

  window.addEventListener(
    "resize",
    function () {
      if (!isMobile()) {
        removeZoomImmediately();
      }
    },
    {
      passive: true
    }
  );

  function initialize() {
    removeOldZoom();
    injectStyles();

    document
      .querySelectorAll(
        '[class*="ai-sneaker-pdp-mobile-gallery-"] img'
      )
      .forEach(function (image) {
        image.setAttribute(
          "draggable",
          "false"
        );
      });
  }

  if (
    document.readyState === "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      initialize
    );
  } else {
    initialize();
  }

  document.addEventListener(
    "shopify:section:load",
    initialize
  );
})();